import React, { useState, useEffect } from "react";

import { collection, getDocs } from "firebase/firestore";
import { fireDB } from "../config";
import { Box, Container, Grid } from "@mui/material";
import ProductList from "../components/ProductList";
export default function Products() {
  const [products, setProduct] = useState([]);
  // get all products
  useEffect(() => {
    getProducts().then((res) => {
      setProduct(res);
    });
  }, []);

  async function getProducts() {
    var dataforTheProducts = [];
    const productForMenu = collection(fireDB, "products");
    const docOfMenuProducts = await getDocs(productForMenu);
    docOfMenuProducts.forEach((doc) => {
      var tempData = doc.data();

      dataforTheProducts.push({
        product_id: doc.id,
        name: tempData.name,
        product_img: tempData.image,
        product_price: tempData.price,
      });
    });

    return dataforTheProducts;
  }

  return (
    <Container sx={{ my: 2 }}>
      {products.length !== 0 ? (
        <Grid container spacing={2}>
          {products.map((item, index) => (
            <Grid item lg={3} md={4} sm={6} xs={12} key={index}>
              <ProductList
                name={item.name}
                image={item.product_img}
                id={item.product_id}
                price={item.product_price}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Box>Loading...</Box>
      )}
    </Container>
  );
}
